// Флаги функциональности бэкофиса.
// OTC-раздел: при false не отображается в меню и его страницы не смонтированы.
// Менять вместе с otc-группой роутов в gateway/routes/api.php и OTC_ENABLED
// в frontend/src/utils/p2pRoutes.ts.
export const OTC_ENABLED = true;
